import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { Card, CardBody, Input, FormGroup, Label } from 'reactstrap';

import AddonsApi from 'apis/Addons';

import 'assets/scss/addons.css';
import { insertIdtoUrl, ROUTES } from '../../constants/Routes';
import Toaster from '../Toaster';

class AddonsRequest extends Component {
  constructor() {
    super();
    this.state = {
      addons: [],
      activeAddons: [],
      isFilterActive: false
    }
  }

  componentDidMount = () => {
    this.fetchAddons();
    this.fetchActiveAddons();
  }

  fetchAddons = () => {
    AddonsApi.fetchAll().then(({ data }) => {
      this.setState({ addons: data })
    }).catch((error) => {
      Toaster.getFailureToaster(error, 'exclamation-triangle', 'Error while fetching addons');
    })
  }

  fetchActiveAddons = () => {
    AddonsApi.fetchAll({ activated: true }).then(({ data }) => {
      this.setState({ activeAddons: data })
    }).catch((error) => {
      Toaster.getFailureToaster(error, 'exclamation-triangle', 'Error while fetching addons');
    })
  }

  handleFilter = () => {
    this.setState(prevState => ({ isFilterActive: !prevState.isFilterActive }));
  }

  render() {
    const { addons, activeAddons, isFilterActive } = this.state;
    const renderAddons = isFilterActive ? activeAddons : addons;
    const addonsList = renderAddons.map(({ business }) => {
      const { id, name } = business;
      return (
        <li>
          <NavLink className="text-primary font-weight-bold" to={insertIdtoUrl(ROUTES.REQUEST_BUSINESS_ADD_ONS, id)}>
            {name}
          </NavLink>
        </li>
      )
    });

    return (
      <div className="container">
        <div className="row addons-container justify-content-between">
          <div className="col-10">
            <div>
              <span className="title">Developer Tools</span>
            </div>
            <div>
              <span className="subtitle">Add-On Requests</span>
            </div>
            <div className="d-flex justify-content-end mb-2">
              <FormGroup check>
                <Input onChange={this.handleFilter} type="checkbox" name="check" id="exampleCheck" checked={isFilterActive} />
                <Label for="exampleCheck" check>Show Activated</Label>
              </FormGroup>
            </div>
            <Card className="border-0">
              <CardBody>
                <ul>
                  {addonsList}
                </ul>
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    );
  }
};

export default AddonsRequest;



// WEBPACK FOOTER //
// ./src/components/Addons/Requests.js